import React, { useRef, useState, useContext, Fragment } from 'react';
import SingleVideoSlide from './singleVideoSlide';
import Carousel from '../../components/carousel';
import PageContext from '../../contexts/pageContext';

import useCoursePromotionPage from './styles';

function CoursePromotionPage({ sectionData, extraProps = {}, sectionIndex }) {
  const {
    layout: { containerWidth },
    countryCode,
    currencySymbol,
    isMobile
  } = useContext(PageContext);
  const classes = useCoursePromotionPage({ containerWidth, isMobile });

  return (
    <div className={classes.courseSuperContainer}>
      <div className={classes.videoTestimonialContainer}>
        <div className={classes.sectionContainer}>
          <SingleVideoSlide
            data={sectionData.components[0].metadata}
            courseBuyNow={extraProps.courseBuyNow}
            showCourseInstallment={extraProps.showCourseInstallment}
            conversions={extraProps.conversions}
            sectionIndex={sectionIndex}
            countryCode={countryCode}
            currencySymbol={currencySymbol}
          />
        </div>
      </div>
    </div>
  );
}

export default CoursePromotionPage;
